// extracted by mini-css-extract-plugin
export default {"container":"kanjiSuggestion_container__-Ds0C","label":"kanjiSuggestion_label__aNQ88","kanji":"kanjiSuggestion_kanji__m6dPQ","cancel":"kanjiSuggestion_cancel__WLcBR"};